import * as React from 'react';
import { FeatureCollection } from '@turf/helpers';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import FileDropZone from '../../../../components/Elements/FileDropZone';
import { GeojsonConverterFactory } from '../../../../utils/geojson';
import { INTERNAL_FIELD_ID } from '../../../../utils/mapUtils';

interface IImportPanelProps {
  onImport: (collection: FeatureCollection) => void,
  onClear: () => void,
};

type ImportInfo = {
  feature_count: number,
  properties: string[]
};

export const ImportPanel = ({ onImport, onClear }: IImportPanelProps) => {

  const [info, setInfo] = useState<ImportInfo | null>(null);
  const [collection, setCollection] = useState<FeatureCollection | null>(null);

  useEffect(() => {
    // extract summary info from the collection.
    if (collection && collection.features.length > 0) {
      setInfo({
        feature_count: collection.features.length,
        properties: collection.features[0].properties ? Object.keys(collection.features[0].properties) : []
      })
    }
  }, [collection]);

  const onFiles = async (files: File[]) => {
    console.log('files', files);
    try {
      // get the reader given the file extension
      const extension = getFileExtension(files[0]);
      const reader = GeojsonConverterFactory.create(extension);

      // read the collection
      const collection = await reader.read(files[0]);
      setCollection(collection);

      // pass the collection to the listener
      onImport(collection);
    } catch (error) {
      console.error(error);
    }
  };

  const getFileExtension = (file: File) : string => {
    const extension = file.name.split('.').pop();

    if(!extension) {
      throw new Error('File is missing extension. Unable to determine file reader.');
    }

    return extension.toLowerCase();
  }

  const fileInfo = () => (
    info ? 
    <div>
        <h4 className="text-xl">File Information</h4>
        <dl className="border-bottom pb-2 row text-sm">
          <dt className="col-sm-5">Feature Count</dt>
          <dd className="col-sm-7">{info.feature_count}</dd>
          <dt className="col-sm-5">Properties</dt>
          <dd className="col-sm-7">{info.properties.length ? info.properties.filter((k:string) => k !== INTERNAL_FIELD_ID).join(', ') : 'no properties'}</dd>
        </dl>
        <div className="d-grid">
          <Button variant="primary" className="w-100" disabled={collection == null} onClick={(e: any) => {
            setCollection(null);
            onClear();
          }}>
            Clear Imported Features
          </Button>
        </div>     
    </div> : null
  );

  const panelUnsetStyle = {
    top: "30%",
    left: "20%",
    right: "20%",
    width: "60%",
    height: "325px",
  }

  const panelSetStyle = {
    width: "350px",
  }

  return (
    <div className="control-panel d-flex flex-column p-4 rounded shadow-lg text-dark position-fixed" style={collection ? panelSetStyle : panelUnsetStyle}>
      { !collection ? 
      <div className="d-flex flex-column flex-fill">
        <h4 className="mb-4">Import block boundaries</h4>
        <div className="alert alert-dark" role="alert">
          Supported format: zipped shapefile
        </div>

        <FileDropZone 
          message="Drop files here, or click to select a file. Maxmimum file size 100MB"
          drag_message="Drop files here ..."
          file_types={['.zip']}
          OnDropFiles={(files: any) => onFiles(files)} /> 
      </div> : fileInfo() 
      }
    </div>
  );
}